export default "__VITE_ASSET__Bk1MbS6I__"